// Pour le dashboard Admin
import React from "react";
import DashboardLayout from "../../pages/Dashboard";

const AdminDashboard: React.FC = () => {
  return <DashboardLayout role="admin" />;
};

export default AdminDashboard;